import axios from "axios";

export const correiosAPI = {
  cep: (cep) => axios.get(`https://viacep.com.br/ws/${cep}/json/`),
};
